import { app, Component } from 'apprun';
import { __, } from './Txlat';

const search = () => {
  const url = new URL(window.location.href);
  const keyword = (document.querySelector('input[name="keyword"]') as HTMLInputElement).value;
  const name = (document.querySelector('input[name="name"]') as HTMLInputElement).value;
  const last_keyword_search = url.searchParams.get('keyword');
  const last_Name_search = url.searchParams.get('name');
  if (keyword !== last_keyword_search || name !== last_Name_search) {
    url.searchParams.set('keyword', keyword);
    url.searchParams.set('name', name);
    window.history.pushState({}, '', url.href);
    app.run('#');
  }
  return false;
};

export default class searchAgencyForm extends Component {
  view = () => {
    const params = new URLSearchParams(location.search);
    const keyword = params.get('keyword') ? params.get('keyword').trim() : '';
    const name = params.get('name') ? params.get('name').trim() : '';
    return (
      <div class="container" >
        <form autocomplete="off" onsubmit={search}>
          <div class="d-flex flex-row flex-lg-nowrap">
            <input type="text" name="name" class="form-control m-1" value={name} placeholder={__('"Office Name"')} />
            <input name="keyword" type="text" class="form-control m-1" value={keyword} placeholder={__('"City", "Postal Code"')} />
            <button type="submit" class="btn btn-search btn-secondary m-1">{__('Search')}</button>
          </div>
        </form>
      </div>
    );
  };
}
